var map = {
	"./audio-placeholder": 800,
	"./audio-placeholder.png": 800,
	"./avatar-missing": 512,
	"./avatar-missing.png": 512,
	"./avatar-missing.svg": 881,
	"./halloween/clouds": 801,
	"./halloween/clouds.png": 801,
	"./halloween/halloween-emblem": 802,
	"./halloween/halloween-emblem.svg": 802,
	"./halloween/spider": 803,
	"./halloween/spider.svg": 803,
	"./halloween/spiderweb": 804,
	"./halloween/spiderweb.svg": 804,
	"./halloween/starfield": 805,
	"./halloween/starfield.png": 805,
	"./halloween/twinkle": 806,
	"./halloween/twinkle.svg": 806,
	"./header-missing": 574,
	"./header-missing.png": 574,
	"./reticle": 807,
	"./reticle.png": 807,
	"./soapbox-logo": 575,
	"./soapbox-logo-white": 576,
	"./soapbox-logo-white.svg": 576,
	"./soapbox-logo.svg": 575,
	"./sprite-post-functions": 808,
	"./sprite-post-functions.png": 808,
	"./video-placeholder": 809,
	"./video-placeholder.png": 809,
	"./void": 810,
	"./void.png": 810,
	"./web-push/web-push-icon_expand": 811,
	"./web-push/web-push-icon_expand.png": 811,
	"./web-push/web-push-icon_favourite": 812,
	"./web-push/web-push-icon_favourite.png": 812,
	"./web-push/web-push-icon_reblog": 813,
	"./web-push/web-push-icon_reblog.png": 813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 880;